import React from 'react';
import WyscoutPlayerDataPanel from '@/components/players/WyscoutPlayerDataPanel';
import {useWorkspace} from '@/context/WorkspaceContext';
import {PlayerDetail} from '@/features/players/api';
import {PlayerTab} from '@/features/players/types';
import {Capability} from '@/services/api/v2';
import {PlayerDetailSection} from './SquadModeSections';

interface Props { player: PlayerDetail; playerId: string; tab: PlayerTab; capabilities: Capability[]; selectedMatchId?: number | null; onOpenFixture?: (matchId: number, trigger: HTMLButtonElement) => void }

const ScoutingModeSections: React.FC<Props> = props => {
  const {currentWorkspace} = useWorkspace();
  return (
    <div className="min-w-0 space-y-4">
      <PlayerDetailSection {...props} />
      {props.tab === 'overview' && currentWorkspace?.id && <WyscoutPlayerDataPanel workspaceId={currentWorkspace.id} player={props.player} capabilities={props.capabilities} selectedMatchId={props.selectedMatchId} onOpenFixture={props.onOpenFixture} />}
    </div>
  );
};
export default ScoutingModeSections;
